import React from "react";
import { Controls, IFormStyles, useFormStyles } from "../.";
import { FormGroup, FormGroupProps, FormGroupType } from "../misc/formGroup";

interface FormTextProps extends Controls.ControlTextProps {
    isLoading?: boolean | undefined
    label?: string | undefined
    groupType?: FormGroupType | undefined;
    labelWidth?: string | undefined;
}

const ComponentProps = (props: FormTextProps): Controls.ControlTextProps => {
    const componentProps = Object.assign({}, props);
    delete componentProps.isLoading;
    delete componentProps.groupType;
    delete componentProps.labelWidth;

    delete componentProps.label;
    delete componentProps.isOptional;
    delete componentProps.tooltip;

    componentProps.isHidden = props.isHidden;

    return componentProps;
}

const GroupProps = (props: FormTextProps): FormGroupProps => {
    const groupProps: FormGroupProps = {
        controlStyles: props.controlStyles,
        isLoading: props.isLoading,
        disabled: props.disabled,
        groupType: props.groupType,
        labelWidth: props.labelWidth,

        label: props.label,
        isOptional: props.isOptional,
        tooltip: props.tooltip,
        isHidden: props.isHidden,
        required: props.required,
    };

    return groupProps;
}

export const FormText: React.FC<Controls.ControlTextProps> = (props) => {
    const styles: IFormStyles = useFormStyles();

    return (
        <FormGroup  {...GroupProps(props)}>
            <Controls.ControlText {...ComponentProps(props)} controlStyles={styles.control} />
        </FormGroup>
    );
};